<template>
  <div>
     <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="yes"
        src="http://emall.laoban100.com/onlinemall/message"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
  </div>
</template>

<script>
export default {
  name: 'ElevenNew',
  components: {},
  data () {
    return {
    }
  },

  computed: {},

  mounted () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
#iframeContain{
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  border:0;
}
</style>



// WEBPACK FOOTER //
// index.vue?502c9f51